import Resize from 'vuetify/lib/directives/resize';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrapper",staticClass:"wrapper"},[_c('svg',{directives:[{def: Resize,name:"resize",rawName:"v-resize",value:(_vm.debounceOnResize),expression:"debounceOnResize"}],ref:"svg"})])}
var staticRenderFns = []

export { render, staticRenderFns }